import Cookies from "js-cookie";

const TOKEN_KEY = "authToken"; // Key for storing the token
const TOKEN_EXPIRED_TIME = "tokenExpiredTime"; // Key for storing the token expired time

export const CookieService = {
  /**
   * Save a token in the cookie
   * @param token - The authentication token
   * @param days - Number of days until expiration (default: 7)
   */
  setToken: (token: string, days: number = 7): void => {
    Cookies.set(TOKEN_KEY, token, { expires: days, secure: true });
  },

  /**
   * Get the stored token from cookies
   * @returns The authentication token or undefined if not found
   */
  getToken: (): string | undefined => {
    return Cookies.get(TOKEN_KEY);
  },

  /**
   * Remove the authentication token from cookies (logout)
   */
  removeToken: (): void => {
    Cookies.remove(TOKEN_KEY);
    Cookies.remove(TOKEN_EXPIRED_TIME);
  },

  /**
   * Remove the token expired time from cookies (logout)
   */
  setTokenExpiredTime: (expriedTime: Date, days: number = 7): void => {
    Cookies.set(TOKEN_EXPIRED_TIME, expriedTime.toISOString(), {
      expires: days,
      secure: true,
    });
  },

  /**
   * Get the stored token expired time from cookies
   * @returns The token expired time or undefined if not found
   */
  getTokenExpiredTime: (): string | undefined => {
    return Cookies.get(TOKEN_EXPIRED_TIME);
  },

  isTokenExpiringSoon: (bufferMs = 300_000): boolean => {
    const expiredTimeStr = Cookies.get(TOKEN_EXPIRED_TIME);
    if (!expiredTimeStr) return true;
    return new Date(expiredTimeStr).getTime() - Date.now() < bufferMs;
  },
};
